import { LandingCompare } from "@/components/landing/compare";
import { LandingCta, LandingFooter } from "@/components/landing/cta";
import { LandingHero } from "@/components/landing/hero";
import { LandingHow } from "@/components/landing/how";
import { LandingNav } from "@/components/landing/nav";
import { LandingProblem } from "@/components/landing/problem";
import { LandingProof } from "@/components/landing/proof";
import { LandingStages } from "@/components/landing/stages";
import { useSkipLoginGate } from "@/components/auth-bypass-redirect";
import { MISSION_HOME } from "@/lib/auth-callback";
import { useRef } from "react";
import { Navigate } from "react-router-dom";

export function LandingPage() {
  const scrollerRef = useRef<HTMLDivElement>(null);
  const { skip, loaded, productionHost } = useSkipLoginGate();
  if (skip) return <Navigate to={MISSION_HOME} replace />;
  if (!loaded && !productionHost) {
    return (
      <div
        className="mission-surface relative h-full min-h-0 bg-black"
        role="status"
        aria-busy="true"
        aria-label="Loading"
      />
    );
  }

  return (
    <div
      ref={scrollerRef}
      className="mission-surface relative h-full min-h-0 overflow-y-auto overflow-x-hidden bg-black text-[#f0f0fa]"
    >
      <LandingNav scrollerRef={scrollerRef} />
      <LandingHero scrollerRef={scrollerRef} />
      <LandingProblem />
      <LandingStages />
      <LandingHow />
      <LandingCompare />
      <LandingProof />
      <LandingCta />
      <LandingFooter />
    </div>
  );
}
